import React from 'react'
import { PropagateLoader } from 'react-spinners'

export default function Loader() {
    return (
        <>
            <div className="text-center mb-3">
                <PropagateLoader
                    color="#FF6700"
                    size={20}
                />
            </div>
        </>
    )
}
